import React from "react";

// Pedaços comuns das telas de aula grátis (candidato e parceiro) — 17/10/2026.
export const quando = (iso) => new Date(iso).toLocaleString("pt-BR", { weekday: "short", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

export const STATUS_AULA = {
  pedida: { txt: "Aguardando o professor", cls: "bg-amber-100 text-amber-900" },
  sugerida: { txt: "Outro horário sugerido", cls: "bg-amber-100 text-amber-900" },
  confirmada: { txt: "Confirmada", cls: "bg-green-100 text-green-900" },
  realizada: { txt: "Realizada", cls: "bg-slate-100 text-slate-700" },
  recusada: { txt: "Não aceita", cls: "bg-red-100 text-red-800" },
  cancelada: { txt: "Cancelada", cls: "bg-red-100 text-red-800" },
  expirada: { txt: "Expirou sem resposta", cls: "bg-slate-100 text-slate-600" },
};

// Horários livres agrupados por dia; um clique escolhe.
export function EscolherHorario({ livres, valor, onChange, vazio }) {
  if (!livres.length) return <p className="text-gray-500 mt-1">{vazio}</p>;
  const porDia = {};
  livres.forEach((l) => {
    const dia = new Date(l.inicio).toLocaleDateString("pt-BR", { weekday: "long", day: "2-digit", month: "2-digit" });
    (porDia[dia] = porDia[dia] || []).push(l);
  });
  return (
    <div className="mt-1 space-y-2 max-h-64 overflow-y-auto">
      {Object.entries(porDia).map(([dia, lista]) => (
        <div key={dia}>
          <div className="text-[11px] font-semibold text-gray-500 capitalize">{dia}</div>
          <div className="flex flex-wrap gap-1 mt-0.5">
            {lista.map((l) => (
              <button key={l.inicio} type="button" onClick={() => onChange(l.inicio)}
                className={`rounded-lg border px-2.5 py-1 text-xs font-semibold ${valor === l.inicio ? "bg-brand text-white border-brand" : "border-gray-300 hover:bg-slate-50"}`}>
                {new Date(l.inicio).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })} · {l.duracaoMin} min
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
